module.exports = __webpack_public_path__ + "img/erweima_zc.7a54e8d5.png";